



































import {Vue, Component, Prop} from "vue-property-decorator";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import {ITestimonial, ITestimonialDTO, TestimonialService} from "./../services/testimonial.service";
import {HashMap} from "./../services/base.service";
import StarRating from '@/components/ui/StarRating.vue';


@Component({
    name: "TestimonialForm",
    components: {
        FormGroup,
        StarRating,
    }
})
export default class TestimonialForm extends Vue {

    @Prop()
    public id!: string;

    public initialized = false;
    private submission!: ITestimonialDTO;
    private service!: TestimonialService;

    private errors: HashMap<string> = {};

    private submitted = false;

    private rating: number = 0;
    private name: string = "";

    private loading: boolean = false;

    private clear() {
        this.submission = {
            companyName: "",
            name: "",
            email: "",
            anonymous: false,
            rating: 1,
            testimonial: "",
        }
        this.rating = 0;
        this.errors = {};
    }

    private ratingUpdate(i: number) {
        this.submission.rating = i;
    }

    private async created() {
        this.initialized = false;
        this.service = new TestimonialService();
    
        if (this.id) {
            const res = await this.service.getOne(this.id);

            if (res.success) {
                this.submission = res.result;
                if (res.result.submitted) {
                    this.$emit('previously-submitted');
                } else {
                    this.$emit('initialized');
                    this.initialized = true;
                }
            } else {
                this.$emit('404');
            }
        } else {
            this.clear();
            this.$emit('initialized');
            this.initialized = true;
        }
    
        
    }

    private async submit() {
        this.loading = true;
        this.errors = {};
        this.submission.rating = this.rating;
        const response = await this.service.submit(this.id, this.submission);
        this.loading = false;
        if (response.success) {
            this.submitted = true;
            this.$emit('success');
        }
        else {
            this.errors = response.error;
        }
    }
}

